import React from "react";
import { Article } from "../../types";
import "./ArticleCard.css";

interface ArticleCardProps {
  article: Article;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <a
      href={article.link}
      target="_blank"
      rel="noopener noreferrer"
      className="card-link"
    >
      <div className="article-card">
        {article.image_url && (
          <img
            src={article.image_url}
            alt={article.title}
            className="card-image"
          />
        )}
        <div className="card-content">
          <div className="card-meta">
            <span className="card-category">{article.category}</span>
            <span className="card-source">{article.source}</span>
          </div>
          <h2 className="card-title">{article.title}</h2>
          <p className="card-description">{article.description}</p>
          <p className="card-date">{formatDate(article.publication_date)}</p>
        </div>
      </div>
    </a>
  );
};

export default ArticleCard;
